module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-md-b86079ee22abb493faf0e9ddd422cd2b.svg";